// extracted by mini-css-extract-plugin
export default {"container":"Loading_container__UT5cj","ring":"Loading_ring__xZosv","animateC":"Loading_animateC__LOn1I","animate":"Loading_animate__HqCzq"};